<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2024-02-23 13:54:22
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-05-08 10:22:22
 * @FilePath: /wemeet-iam/Users/hvv/weMeetSpace/wemeet-poster/src/views/mini-h5/pages/user_home_page/index.vue
 * @Description: 
 * Copyright (c) 2024 by WeMeet, All Rights Reserved. 
-->
<template>
  <div>
    <div class="mh-100vh bg-F5F5F5 overflow-hidden border-box pb-20 pt-10" v-if="!isDelete">
      <div style="padding:0 12px;">
        <van-swipe class="my-swiper" :loop='false' :show-indicators='false' @change="swiperChange" ref="mySwiper">
          <van-swipe-item v-for="(item, index) in businessCard" :key="index">
            <!-- 卡片 -->
            <MainPageCard @refresh='refresh' @wxshare='wxshare' :userBaseInfoVo="userBaseInfoVo" :userInfo='userInfo'></MainPageCard>

          </van-swipe-item>
        </van-swipe>
      </div>
      <!-- 按钮 -->
      <MainPageBtn @refresh='refresh' :userBaseInfo="userInfo"></MainPageBtn>
      <!-- 个人介绍 -->
      <MainPageIntroduction :userProfile='userProfile' v-if="userProfile && (userProfile.content != '' || userProfile.attachmentVos.length > 0)" :title='introduceWord'></MainPageIntroduction>
      <!-- 工作经历 -->
      <MainPageResume :recordVos='recordVos' v-if="recordVos && recordVos.length > 0" :title='workExprenice'></MainPageResume>
    </div>
    <div v-else class="d-flex mh-100vh bg-F5F5F5" style=" justify-content: center;align-items: center;flex-direction: column;font-size:16px;color:#262626;">
      <img src="https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/common-default-picture/common-no-data.png" alt="" style="width:200px;height:200px;">
      AI名片已被删除
    </div>

    <img class="aigc" @click="goAigc" src="https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/WeMeet-Static/rabot2.gif" alt="">
    <sharePop ref="sharePop"></sharePop>
  </div>
</template>
<script>
import MainPageCard from './components/MainPageCard.vue'
import MainPageBtn from './components/MainPageBtn.vue'
import MainPageIntroduction from './components/MainPageIntroduction.vue'
import MainPageResume from './components/MainPageResume.vue'
import { GetQueryString } from '@/utils/utils'
import { translateText } from '@/api/common'
import { getUserLanguages, queryUserHomePage, handleSenceQrCode } from '@/api/interNational'
import sharePop from '@/components/sharePop.vue'
export default {
  name: 'mainPage',
  components: { MainPageCard, MainPageBtn, MainPageIntroduction, MainPageResume, sharePop },
  data() {
    return {
      vcardParams: {},
      uid: ``,
      headersNormal: {},
      userInfo: {},
      userBaseInfoVo: {
        qrCodeUrl: '',
      },
      userProfile: {},
      recordVos: [],
      downLoadWord: '',
      saveBusinessCard: '',
      introduceWord: '',
      workExprenice: '',
      isDelete: false,
      successTip: '',
      businessCard: [],
      initialSwipeIndex: 0,
      isInit: false,
      senceKey: null,
      oldLanguage: '',
    }
  },
  mounted() {
    this.senceKey = GetQueryString(`scenesKey`)
    if (!!this.senceKey) {
      var headerClientInfo = { language: 'CN', eventKey: 'WeMeet', appKey: `WX_MINI_WEMEET` }
      this.headersNormal = {
        'x-call-client-info': JSON.stringify(headerClientInfo),
      }
      handleSenceQrCode(this.headersNormal, this.senceKey).then((res) => {
        console.log(res)
        this.uid = res.data.jumpPath
        this.vcardParams = JSON.parse(res.data.params)
        this.language = this.vcardParams.language
        this.queryUserHomePageInfo()
        this.$eventBus.$emit('changeLocaelLanguage', { languageKey: this.language })
      })
    } else {
      this.uid = GetQueryString(`uid`)
      this.language = GetQueryString(`language`)
      this.queryUserHomePageInfo()

      this.$eventBus.$emit('changeLocaelLanguage', { languageKey: this.language })
    }

    this.$eventBus.$on('refreshLocael', (res) => {
      console.log(res)
      this.oldLanguage = this.language
      this.language = res.lang
      this.isInit = false
      this.queryUserHomePageInfo(true)
    })
  },
  methods: {
    wxshare() {
      this.$refs.sharePop.open()
    },
    refresh() {
      this.queryUserHomePageInfo()
    },
    queryUserHomePageInfo(isRefresh) {
      let userInfo = JSON.parse(localStorage.getItem('userInfo'))
      let token = localStorage.getItem('token')
      if (!!token && userInfo.weMeetUid == this.uid) {
        this.$router.push('/mini-h5/index/myPage')
        return false
      }
      getUserLanguages({}, { uid: this.uid }).then((resp) => {
        console.log(resp)
        this.businessCard = resp.data
        if (isRefresh) {
          let langArr = resp.data.filter((v) => v.language == this.language)
          if (langArr.length > 0) {
            this.$toast(this.$t('lang.t321'))
            this.language = !!this.language ? this.language : resp.data[0].language
            this.queryDetail(this.language)
          } else {
            this.$toast(this.$t('lang.t320'))
            this.language = this.oldLanguage
          }
        } else {
          this.language = !!this.language ? this.language : resp.data[0].language
          this.queryDetail(this.language)
        }
      })
    },
    queryDetail(language) {
      queryUserHomePage({}, this.uid, language).then((res) => {
        if (res.code == 12025) {
          this.isDelete = true
          return false
        }
        this.userBaseInfoVo = res.data.userBaseInfoVo
        this.userProfile = res.data.userProfile
        this.recordVos = res.data.recordVos
        this.userInfo = res.data
        this.initialSwipeIndex = this.businessCard.findIndex((v) => v.language == this.language)

        if (!this.isInit) {
          this.$nextTick(() => {
            this.$refs.mySwiper.swipeTo(this.initialSwipeIndex)
            this.isInit = true
          })
        }
      })
    },
    swiperChange(index) {
      console.log(index)
      let language = this.businessCard[index].language
      this.queryDetail(language)
    },
    goAigc() {
      location.href = `${process.env.VUE_APP_H5_BASE_URL}/#/aigc?appKey=WX_MINI_WEMEET&language=${this.$i18n.locale}`
    },
  },
}
</script>


<style lang="less" >
.my-swiper {
  &.van-swipe {
    overflow: initial;
  }
  .van-swipe-item {
    transform: scale(0.98);
  }
}
.aigc {
  position: fixed;
  bottom: 60px;
  right: 10px;
  width: 100px;
  height: 100px;
}
</style>